import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, RespostaNaoResolvida } from './types';

export const INITIAL_STATE: RespostaNaoResolvida = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): RespostaNaoResolvida {
	return produce(state, draft => {
		switch (action.type) {
			case Types.RESPOSTA_NAO_RESOLVIDA_REQUEST: {
				break;
			}
			case Types.RESPOSTA_NAO_RESOLVIDA_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.RESPOSTA_NAO_RESOLVIDA_FAILURE: {
				draft.status = 400;
				draft.data = action.payload;
				break;
			}
			case Types.RESPOSTA_NAO_RESOLVIDA_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
